import { Flex } from 'roo-ui/components';

const ItemGroup = (props) => <Flex flex="1 1 auto" flexDirection="column" p={5} m={0} {...props} />;

export default ItemGroup;
